var template = '';

$(function() {
  
  var r = document.querySelector(':root'),
      $html = $('html');
  
  template = $('html').attr('id').slice(0,-1);

  var $total = $('#click'),
      $sticky = $('#sticky');

  if ($sticky.length == 1) {
    
    var scroll_top = 0;
    var scroll_down_buffer = 0;
    
    function watch_scroll() {
      
      var scroll_top_ = $(window).scrollTop();
  
      if (scroll_top_ > scroll_top) {
        
        scroll_down_buffer++;
        if (scroll_down_buffer > 30) {
          scroll_down_buffer = 0;
          $html.removeClass('sticky');
        }
        
      }
      else {
        
        var sticky_ = $sticky.offset().top;
        if (scroll_top_ > sticky_) {
          $html.addClass('sticky');
        }
        else {
          $html.removeClass('sticky');
        }
  
      }
  
      scroll_top = scroll_top_;
      
    }

    watch_scroll();
    $(window).on('scroll', watch_scroll);

  }
  
  $('.scroll-to').on('click', function() {
    
    var target_ = $(this).data('target');
    
    $('.' + target_).get(0).scrollIntoView({ behavior: 'smooth' });

  });

  $('.toggle').on('click', function() {
    
    var id_ = $(this).attr('class').split(' ')[0];
    
    var $button_el = $('.button.' + id_),
        $svg_el = $('.hero.' + id_ + ' svg'),
        text_ = 'View Sample',
        show_ = 0,
        hide_ = 1;
    
    if ($button_el.text() == text_) {
      text_ = 'View Characters';
      show_ = 1;
      hide_ = 0;
    }

    $svg_el.eq(show_).css('display', 'block');
    $svg_el.eq(hide_).css('display', 'none');
    $button_el.text(text_);
    
  });

  $('.update').on('click', function() {

    var $el = $(this);
    
    var id_      = $el.attr('id').slice(0, -1),
        text_    = 'remove from cart',
        loading_ = 'adding ...',
        class_   = 'update remove active',
        remove_  = false,
        TODO_    = true;;    

    if ($el.hasClass('remove')) {
  
      text_ = 'add to cart';
      loading_ = 'removing ...';
      class_ = 'update add active';
      remove_ = true;
      TODO_ = false;
      
    }

    $html.addClass('refresh-cart');
    $el.html('<span class="progress">....</span>').prop('class', class_);

    // $.post(url_, data_, function(d) {
    update_cart(id_, remove_, function() {
      
      refresh_cart(function() {
        $el.text(text_);
        if (!TODO_) {
          $el.removeClass('active');
        }
        $html.removeClass('refresh-cart');
      });
      
    });

  });

  function refresh_cart(complete) {
    $.getJSON('/cart.js', function (d) {
      $('span', $total).text('Cart(' + d.item_count + ')');
      complete();
    });    
  }
  
  var color_1 = r.style.getPropertyValue('--sample-primary-color'),
      color_2 = r.style.getPropertyValue('--sample-secondary-color');

  $('#switch button').on('click', function() {

    var $el_ = $(this);

    color_1 = $el_.css('background-color');
    color_2 = $el_.data('secondary');

    set_colors(color_1, color_2, true);
    
  });

  function set_colors(a, b, save) {

    r.style.setProperty('--sample-primary-color', a);
    r.style.setProperty('--sample-secondary-color', b);

    if (save) {
      sessionStorage.setItem("sample-colors", a + '|' + b);
    }
    
  }

  /*
  $('a.disabled').on('click', function(e) {
    e.preventDefault();
    return false;
  });
  */

  $('.order').each(function() {

    var $el_       = $(this),
        $submit_   = $('.order_submit', this),
        $quantity_ = $('.order_quantity', this),      
        $discount_ = $('.order_discount', this),
        $total_    = $('.order_total', this);

    $('li', this).on('mouseover', function() {
      
      var handle_ = $(this).attr('class').split(' ')[0];

      $('img', $el_).removeClass('active');
      
      $('.thumb.' + handle_, $el_).addClass('active');
      
      
    });

    $('li', this).on('mouseout', function() {
      $('img', $el_).removeClass('active');
    });

    // $('.disabled', this).on('click', function(e) {
    //   e.preventDefault();
    //   return false;
    // });
    
    $('input', this).on('click', function(e) {
      
      var $checkbox_ = $(this);
      var id_        = $checkbox_.val(),
          active_    = $checkbox_.prop("checked"),
          remove_    = false;

      if (active_) {
        $checkbox_.parents('li').addClass('active');
      }
      else {
        $checkbox_.parents('li').removeClass('active');
        remove_ = true;
      }

      $submit_.html('<span class="progress">....</span>');
      
      update_cart(id_, remove_, function(d) {
        $submit_.text('Checkout');
      });

      var checked_ = $('input:checked', $el_).length,
          checked_text_ = 'Empty Cart';
      if (checked_ != 0) {
        checked_text_ = checked_.toString() + ' x $' + price.toString();
        $submit_.removeClass('disabled');
      }
      else {
        $submit_.addClass('disabled');
      }
      
      $quantity_.text(checked_text_);
    
      var discount_ = Math.floor(checked_ / 3) * price;
      $discount_.text('$' + discount_.toString());
    
      var total_ = (price * checked_) - discount_;  
      $total_.text('$' + total_.toString());
          
      
    });
    
  });

  function monitor_order() {
    
    $.getJSON('/cart.js', function (d) {
  
      for (i = 0; i < d.items.length; i++) {
  
        var id_  = d.items[i].id,
            qty_ = d.items[i].quantity;
        
        if (qty_ > 1) {
          $.post('/cart/change.js', { id: id_, quantity: 1 }, function() { }, 'json');
        }
        // console.log([id_, qty_]);                
        // $.post('/cart/change.js', { id: id_, quantity: 3 }, function() { }, 'json');
        
      }
    
    });

  }

  monitor_order();
  
  function update_cart(id, remove, complete) {

    var active_ = false,
        total_ = 0;

    $.getJSON('/cart.js', function (d) {

      total_ = d.items.length;

      for (i = 0; i < total_; i++) {

        if (d.items[i].id == id) {
          active_ = true;
          break;
        }
        
      }

      if (active_ && !remove) {
        complete();
      }
      else {
        
        var url_  = '/cart/add.js',
            data_ = { "items[]": { 'id': id, 'quantity': 1 } };
          
        if (remove) {
          url_  = '/cart/update.js',
          data_ = { updates: { [id]: 0 } };
        }
    
        $.post(url_, data_, complete, 'json');

      }

    });
    
  }
  
});